module.exports = __webpack_public_path__ + "static/media/wallet.8423b82d.png";